import React, { useEffect, useCallback, useState, useContext } from 'react'
import useQuery from '../../services/useQuery'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import Button from 'syngenta-react-components/dist/components/Button'
import { GlobalContext } from '../../services/context'

const DocuSignEmbedView = () => {
  const { trackEvent } = useContext(GlobalContext)
  const [docuSignEvent] = useState(useQuery().get('event'))
  const [status, setStatus] = useState('LOADING')

  const sendSuccess = useCallback(() => {
    window.parent.postMessage('signing_complete', '*')
  }, [])

  const sendFailure = () => {
    window.parent.postMessage('signing_failed', '*')
  }

  useEffect(()=> {
    if(docuSignEvent === 'signing_complete' || docuSignEvent === 'viewing_complete'){
      setStatus('SUCCESS')
      setTimeout(sendSuccess, 3000)
      trackEvent(`docusign_${docuSignEvent}`)
    } else {
      setStatus('ERROR')
    }
  }, [
    sendSuccess, docuSignEvent, trackEvent
  ])

  return(
    <div>
      {status !== 'ERROR' ?
        <>
          <h3>Please wait..</h3>
          <TableStatus status='LOADING' prompt='Please wait...'/>
        </>
        :
        <>
          <h3>{'Something isn\'t quite right...'}</h3>
          <Button styleType='success' onClick={sendFailure}>Back to dashboard</Button>
        </>
      }
    </div>
  )
}

export default DocuSignEmbedView